import React, { Component } from 'react'

export default class redirect extends Component {
    render() {

        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
          
                // Windows Phone must come first because its UA also contains "Android"
              if (/windows phone/i.test(userAgent)) {
                  window.location.href = "https://appstoreconnect.apple.com/apps/1535753046/testflight/ios/3e1aaf4e-3a62-4083-a13f-d6a0471bd1bb";  
                  return ""
              }
          
              if (/android/i.test(userAgent)) {
                window.location.href = "https://play.google.com/store/apps/details?id=net.sentrics.engage360connect.production";
                return ""
              }
          
              // iOS detection from: http://stackoverflow.com/a/9039885/177710
              if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                window.location.href = "https://appstoreconnect.apple.com/apps/1535753046/testflight/ios/3e1aaf4e-3a62-4083-a13f-d6a0471bd1bb";  
                return ""
              }
          
              return "no device";
          }


        return (
            <div>
                {
                getMobileOperatingSystem() === "no device" ?
                <div className="ConnectRedirectBody">
                    <img
                        alt="sentrics-logo"
                        src="https://engage360.s3.amazonaws.com/sentrics-logo-2.png"
                    />
                    <br/>
                    <p>This link is intended to be opened on a mobile device. Please tap the link on your phone to open the Connect app or to be brought to your app store to download it. Thanks!</p>
                </div> : ""
                }
            </div>
        )
    }
}
